/**
 * Asset dokümanından panelde gösterilecek genel URL üretir (CDN / legacy static).
 * @param {object} asset
 * @returns {string|null}
 */
export function resolveAssetPublicUrl(asset) {
    if (!asset) return null;
    const id = asset._id;
    if (!id) return null;
    const path = asset.path || "";
    const pathStr = typeof path === "string" ? path : "";
    const isWhatsapp = pathStr.indexOf("whatsapp") !== -1;
    const isInstagram = pathStr.indexOf("instagram") !== -1;
    const isMessenger = pathStr.indexOf("messenger") !== -1;
    const isTelegram = pathStr.indexOf("telegram") !== -1;
    const isFacebook = pathStr.indexOf("facebook") !== -1;
    const isPlatform = isWhatsapp || isInstagram || isTelegram || isMessenger || isFacebook;
    if (isPlatform) {
        return "https://static.supsis.live/" + pathStr;
    }
    if (asset.v2Format && asset.cdnUrl) {
        return asset.cdnUrl;
    }
    const ext = asset.ext ? "." + asset.ext : "";
    return "https://static.supsis.live/" + pathStr + id + ext;
}
